import React, { Fragment } from "react";
import moment from "moment";
import SummaryMessage from "./components/SummaryMessage";
import ReportMetrics from "./components/ReportMetrics";
import SiteMonthSelect from "./components/SiteMonthSelect";
import { Container, Aside, Report } from "./ActionSummary.styles";

export interface MonthYear {
  timestamp: moment.Moment;
  month: string;
  year: string;
}

interface Props {
  data: any;
  onMonthChange: ({ value }: { value: moment.Moment }) => void;
  monthValue: MonthYear;
  onSiteChange: ({ value }: { value: string }) => void;
  siteOptions: Array<{ [key: string]: string }>;
  siteValue: { [key: string]: string };
}
const ActionSummary: React.FC<Props> = ({
  data,
  onMonthChange,
  monthValue,
  onSiteChange,
  siteOptions,
  siteValue,
}) => (
  <Fragment>
    <SiteMonthSelect
      onMonthChange={onMonthChange}
      monthValue={monthValue}
      onSiteChange={onSiteChange}
      siteOptions={siteOptions}
      siteValue={siteValue}
    />
    <Container>
      <Aside>
        <SummaryMessage month={monthValue.month} />
      </Aside>
      <Report>
        <ReportMetrics
          done={data.done}
          progress={data.progress}
          next={data.next}
        />
      </Report>
    </Container>
  </Fragment>
);

export default ActionSummary;
